<template>
  <div>
    <h1>Les meves incidències</h1>
    <AddTicket/>
    <UserTicketsTable :table_rows="this.user_tickets" :states="states" v-if="this.user_tickets"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserTicketsTable from '@/components/UserTicketsTable'
import AddTicket from '@/components/AddTicket'

export default {
  components: {
    UserTicketsTable,
    AddTicket
  },
  computed: {
    ...mapGetters({
      user_tickets: 'userTickets'
    }),
    states () {
      return this.$store.state.states.map(function (obj) {
        return obj.displayname
      })
    }
  },
  created () {
    this.$store.dispatch('fetchUserTickets')
    this.$store.dispatch('fetchStates')
  }
}
</script>

<style module>
</style>
